export enum ClusterOnboardingErrors {
  ONBOARDINGRUNING = 0,
  MODULESNOTCONFIGURED = 1,
  MISSINGINFORMATIONS = 2
}
